<template>
  <div v-if="product && product.imagenes && product.imagenes.length>0" class="homecenter-card h-100 position-relative bg-white">
    <div class="card-inner d-flex flex-column h-100" @mouseover="details = true" @mouseout="details = false">
      <!-- Image Area (Flush to edges) -->
      <div class="image-area flex-shrink-0 text-center bg-light position-relative" style="cursor: pointer; aspect-ratio: 1/1; border-bottom: 1px solid #f8f9fa;" @click="addProducto(product)">
        
        <!-- Zoom Overlay Button (Top Left) -->
        <button type="button" 
                class="btn-action-overlay btn-zoom-action position-absolute" 
                style="top: 10px; left: 10px; z-index: 10;"
                title="Ampliar imagen / Ver detalle" 
                @click.stop="openZoom(product)">
          <font-awesome-icon icon="search" />
        </button>
        
        <!-- Cotizar / Personalizar Overlay Button (Top Right) -->
        <button type="button" 
                class="btn-action-overlay btn-quote-action position-absolute" 
                style="top: 10px; right: 10px; z-index: 10;"
                title="Cotizar y personalizar producto" 
                @click.stop="addProducto(product)">
          <font-awesome-icon icon="shopping-cart" />
        </button>

        <div v-if="product.imagenes && product.imagenes.length>1" class="view-product h-100 position-relative">
          <figure v-for="(img,index) in product.imagenes" :key="index" class="m-0 h-100">
            <img :class="[index === 0 ? 'img-primary' : (index === 1 ? 'img-secondary' : 'd-none')]" 
                 style="height: 100%; width: 100%; object-fit: cover;" 
                 :src="`${dominio}/img/productos/${img.nombre}`" 
                 :alt="product.nombre" />
          </figure>
        </div>
        <div v-else class="view-product h-100 position-relative">
          <figure v-for="(img,index) in product.imagenes" :key="index" class="m-0 h-100">
            <img class="img-primary" style="height: 100%; width: 100%; object-fit: cover;" :src="`${dominio}/img/productos/${img.nombre}`" :alt="product.nombre" />
          </figure>
        </div>
      </div>
      <div class="details-area text-start flex-grow-1 d-flex flex-column p-3 p-md-4 bg-white" @click="addProducto(product)" style="cursor: pointer;">
        <!-- Horizontal Tags -->
        <div class="tags-container mb-2" v-if="product.etiquetas">
          <span class="badge tag-badge me-1 mb-1" 
                style="background-color: #f1f1f1; color: #666; font-size: 0.6rem; font-weight: 600; border-radius: 3px; cursor: pointer; transition: all 0.2s; padding: 4px 8px; text-transform: uppercase;" 
                v-for="tag in product.etiquetas.split(',')" 
                :key="tag"
                @click.stop="filtrarPorEtiqueta(tag.trim())">
            {{ tag.trim() }}
          </span>
        </div>

        <h2 class="title-producto m-0 mb-2" style="font-size: 1rem; font-weight: 700; color: #000; line-height: 1.3;">
          {{product.nombre}}
        </h2>

        <div class="product-metadata mb-3">
          <div v-if="product.tamano" class="size mb-1" style="font-size: 0.75rem; color: #713083; font-weight: 700;">
            <font-awesome-icon icon="ruler-combined" class="me-1" /> {{ product.tamano }}
          </div>
          <p v-if="product.descripcion" class="description m-0" style="font-size: 0.8rem; color: #666; line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;">
            {{ product.descripcion }}
          </p>
        </div>

        <!-- Prominent Cotizar & Personalizar Button -->
        <button type="button" 
                class="btn btn-quote-custom w-100 mt-auto py-2 d-flex align-items-center justify-content-center gap-2"
                @click.stop="addProducto(product)">
          <font-awesome-icon icon="shopping-cart" />
          <span>Cotizar / Personalizar</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>

  import { SlideXRightTransition,ScaleTransition } from 'vue2-transitions'
  import { mapMutations } from 'vuex'

export default {
  name: 'product',
  props: ['product','scroll'],  
  components: {
    SlideXRightTransition,
    ScaleTransition
  },
  data() {
    return { details: false,
            store:false, 
            dominio:this.$store.state.dominio,
            verProd:0,
            nombre:'',
            imagen:'',
            descripcion:'',
            producto:{},
            modalp:0,
            }
  },
    watch: {
      modalp(val) {
         const ahora = new Date();

  const horas = String(ahora.getHours()).padStart(2, '0');
  const minutos = String(ahora.getMinutes()).padStart(2, '0');
  const segundos = String(ahora.getSeconds()).padStart(2, '0');
    const milisegundos = String(ahora.getMilliseconds()).padStart(3, '0');

  const horaCompleta = `${horas}:${minutos}:${segundos}.${milisegundos}`;
        console.log("modalp cambió a:", val,horaCompleta);
      }
    },
    methods : {
       ...mapMutations(['saveToCart']),
      
       vistaRapida(producto){
         this.verProd=1
         this.producto=producto.imagen
         this.nombre=producto.nombre
         this.descripcion=producto.descripcion
       },
       addProducto(value){
        this.$emit('open-detail', value);
      },
      openZoom(value){
        this.$emit('open-zoom', value);
      },
      filtrarPorEtiqueta(tag) {
        this.$store.commit('updateFilterCat', null); // Reset category filter for global search
        this.$store.commit('updateFilterTag', tag);
        
        if (this.$route.name !== 'store') {
            this.$router.push({ name: 'store' }).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
            });
        }
        window.scrollTo(0,0);
      }
     
    },
    created() {
      this.$route.name == 'store' ? this.store = true : ''
    },
    
}
</script>

<style>
.product-disabled{
  opacity:0.7;
}
.flying-badge{
    position: absolute;
    right: -27px;
    border-radius: 40px;
    padding: 9px;
}
.card-title,.card-text{
  text-shadow:1px 2px 8px black;
}
.image-area {
  overflow: hidden;
  position: relative;
}
.view-product{
  cursor:pointer;
  position: relative;
  width: 100%;
  height: 100%;
}
.img-primary {
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  opacity: 1;
  z-index: 1;
}
.img-secondary {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  opacity: 0;
  z-index: 2;
}

/* Transición en hover: Muestra la segunda imagen */
.image-area:hover .img-primary {
  opacity: 0;
  transform: scale(1.04);
}
.image-area:hover .img-secondary {
  opacity: 1;
  transform: scale(1.04);
}

/* Si sólo tiene 1 imagen, aplica zoom suave */
.image-area:hover .view-product figure:only-child img {
  opacity: 1;
  transform: scale(1.05);
}

/* Dynamic Overlay Actions Container */
.product-actions-overlay {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.btn-action-overlay {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: #713083;
  border: 1px solid rgba(113, 48, 131, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  opacity: 0.9;
  transition: all 0.25s ease;
}

.btn-action-overlay:hover {
  background: #713083 !important;
  color: #ffffff !important;
  transform: scale(1.15) !important;
  box-shadow: 0 4px 15px rgba(113, 48, 131, 0.4) !important;
}

.btn-quote-custom {
  background-color: #713083;
  color: #ffffff;
  font-size: 0.82rem;
  font-weight: 700;
  border: none;
  border-radius: 8px;
  transition: all 0.25s ease;
  box-shadow: 0 3px 8px rgba(113, 48, 131, 0.25);
}

.btn-quote-custom:hover {
  background-color: #542263;
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 5px 14px rgba(113, 48, 131, 0.4);
}

.homecenter-card {
  transition: all 0.3s ease;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #f4f4f4;
  box-shadow: 0 2px 10px rgba(0,0,0,0.02);
}
.homecenter-card:hover {
  box-shadow: 0 8px 20px rgba(0,0,0,0.08) !important;
  transform: translateY(-4px);
}
.title-producto {
  color: #000;
}
.tag-badge:hover {
  transform: scale(1.05);
  background-color: #e1e1e1 !important;
  color: #000 !important;
}
</style>

